export interface Section {
    title: string;
    index: string;
    url: string;
    subsections: Section[];
}

export type FileStructure = Section[];


export const fileStructure: FileStructure = [
    {
        title: "About This Report",
        index: "",
        url: "about-this-report",
        subsections: []
    },
    {
        title: "The Analytic Sample",
        index: "1.",
        url: "the-analytic-sample",
        subsections: [
            {
                title: "Introduction", index: "",
                url: "introduction",
                subsections: []
            },
            {
                title: "Demographic Characteristics", index: "1.1", 
                url: "demographic-characteristics",
                subsections: [],
            },
            {
                title: "Institutional Persistence", index: "1.2",
                url: "institutional-persistence",
                subsections: []
            },
            {
                title: "Response Rates", index: "1.3",
                url: "response-rates",
                subsections: []
            },
        ]
    },
    {
        title: "Weighing The Factors",
        index: "2.",
        url: "weighing-the-factors",
        subsections: [
            {
                title: "Introduction", index: "", url: "introduction", subsections: []
            },
            {
                title: "Average rank of factors compelling faculty to stay or leave", index: "2.1",
                url: "average-rank-of-factors",
                subsections: []
            },
            {
                title: "Top factors in the decision to stay or leave", index: "2.2",
                url: "top-factors-in-the-decision-to-stay-or-leave", subsections: []
            },
            {
                title: "Comments on whether to stay or accept the outside offer (Open-text Response)", index: "2.3", url: "comments-on-whether-to-stay-or-accept", subsections: []
            },
            {
                title: "Responses to “Other (please specify)”", index: "", url: "responses-to-other", subsections: []
            },
        ]
    },
    {
        title: "Spouses & Partners",
        index: "3.",
        url: "spouses-&-partners",
        subsections: [
            {
                title: "Introduction", index: "", url: "introduction", subsections: []
            },
            {
                title: "Marital status and spousal/partner employment", index: "3.1", url: "marital-status", subsections: []
            },
            {
                title: "Role of spouse/partner career in search and outside offer", index: "3.2", url: "role-of-career", subsections: [
                    {
                        title: "Responses to “Other (please specify)”", index: "", url: "responses-to-other-prompts-career", subsections: []
                    }
                ]
            },
            {
                title: "Employment status of spouses/partners", index: "3.3", url: "employment-status", subsections: []
            },
            {
                title: "Type of positions held by spouses/partners", index: "3.4", url: "types-of-positions", subsections: [
                    {
                        title: "Responses to “Other (please specify)”", index: "", url: "responses-to-other-prompts-positions", subsections: []
                    }

                ]
            },
        ]

    },
    {
        title: "The Search",
        index: "4.",
        url: "the-search",
        subsections: [
            {
                title: "Introduction", index: "", url: "introduction", subsections: []
            },
            {
                title: "Time spent considering leaving/spent searching", index: "4.1", url: "time-spent", subsections: []
            },
            {
                title: "Ultimate motivation for the search", index: "4.2", url: "ultimate-motivation-for-the-search", subsections: []
            },
            {
                title: "Applications sent and offers received", index: "4.3", url: "applications-sent-and-offers-received", subsections: []
            },
            {
                title: "Initial contact between your faculty and offering institution",
                index: "4.4",
                url: "initial-contact-between-your-faculty-and-offering-institution",
                subsections: [
                    {
                        title: "Responses to “Other (please specify)”", index: "", url: "responses-to-other-prompts-initial-contact",
                        subsections: []
                    }

                ]
            },
        ]

    },
    {
        title: "The Negotiation Process",
        index: "5.",
        url: "the-negotiation-process",
        subsections: [
            {
                title: "Introduction", index: "", url: "introduction", subsections: []
            },
            {
                title: "Your institution’s first notification of outside offer", index: "5.1", url: "first-notification", subsections: []
            },
            {
                title: "Seriousness with which faculty viewed the outside offer", index: "5.2", url: "seriousness", subsections: []
            },
            {
                title: "Number of days from notification to counteroffer", index: "5.3", url: "counteroffer-notification", subsections: []
            },
            {
                title: "Your institution’s handling of the process (Open-text Response)", index: "5.4", url: "your-institutions-handling-of-process", subsections: []
            },
        ]

    },
    {
        title: "The Negotiation Terms",
        index: "6.",
        url: "the-negotiation-terms",
        subsections: [
            {
                title: "Introduction", index: "", url: "introduction", subsections: []
            },
            {
                title: "Origin of outside offers", index: "6.1", url: "origin-of-outside-offers", subsections: []
            },
            {
                title: "Rank, tenure and title: Pre-offer vs. Offer", index: "6.2", url: "rank-tenure-title", subsections: []
            },
            {
                title: "Compensation: Pre-offer vs. Offer vs. Counteroffer", index: "6.3", url: "compensation", subsections: []
            },
            {
                title: "Permissible uses of startup funds in outside offer", index: "6.4", url: "permissible-uses-of-startup-fund", subsections: [
                    {
                        title: "Responses to “Other (please specify)”", index: "", url: "responses-to-other-prompts-permissible-uses-startup-fund", subsections: []
                    }

                ]
            },
            {
                title: "Counteroffers sought and counteroffers received", index: "6.5", url: "counteroffers-sought-and-counteroffers-received", subsections: [
                    {
                        title: "Responses to “Other (please specify)”", index: "", url: "responses-to-other-prompts-counteroffers-sought-and-counteroffers-received", subsections: []
                    }
                ]
            },
            {
                title: "Your counteroffer: Proposed changes", index: "6.6", url: "your-counteroffer-proposed-changes", subsections: [
                    {
                        title: "Responses to “Other (please specify)”", index: "", url: "responses-to-other-prompts-your-counteroffer-proposed-changes", subsections: []
                    }

                ]
            },
            {
                title: "Your counteroffer: Extent to which it matched outside offer", index: "6.7", url: "your-counteroffer-extent-matched", subsections: []
            },
            {
                title: "Your counteroffer: Faculty assessment of comparison (Open-text Response)", index: "6.8", url: "your-counteroffer-faculty-assessment-of-comparison", subsections: []
            },
            {
                title: "Your counteroffer: Why it did not materialize (Open-text Response)", index: "6.9", url: "your-counteroffer-why-it-did-not-materialize", subsections: []
            },
        ]

    },
    {
        title: "The Transition",
        index: "7.",
        url: "the-transition",
        subsections: [
            {
                title: "Introduction", index: "", url: "introduction", subsections: []
            },
            {
                title: "Treatment of faculty after departure intentions are known", index: "7.1", url: "treatment-of-faculty", subsections: []
            },
            {
                title: "Treatment of faculty after departure intentions are known (Open-text Response)", index: "7.2", url: "treatment-of-faculty-text-based-response", subsections: []
            },
        ]

    },
    {
        title: "Overall Impressions",
        index: "8.",
        url: "overall-impressions",
        subsections: [
            {
                title: "Introduction", index: "", url: "introduction", subsections: []
            },
            {
                title: "The top change to convince faculty to stay", index: "8.1", url: "the-top-change-to-convince-faculty-to-stay", subsections: [
                    {
                        title: "Responses to “Other (please specify)”", index: "", url: "responses-to-other-prompts-top-change", subsections: []
                    }

                ]
            },
            {
                title: "Satisfaction with retention efforts", index: "8.2", url: "satisfaction-with-retention-efforts", subsections: []
            },
            {
                title: "Recommendation of department as a place to work", index: "8.3", url: "recommendation-of-department", subsections: []
            },
            {
                title: "Likelihood to seek or entertain a job offer", index: "8.4", url: "likelihood-to-seek-or-entertain-a-job-offer", subsections: []
            },
            {
                title: "Additional comments about decision to stay or accept outside offer (Open-text Response)", index: "8.5", url: "additional-comments-about-decision", subsections: []
            },
        ]

    },
    {
        title: "Preemptive Retentions",
        index: "9.",
        url: "preemptive-retentions",
        subsections: [
            {
                title: "Introduction", index: "", url: "introduction", subsections: []
            },
            {
                title: "Proposed Changes", index: "9.1", url: "proposed-changes", subsections: [
                    {
                        title: "Responses to “Other (please specify)”", index: "", url: "responses-to-other-prompts-proposed-changes", subsections: []
                    }

                ]
            },
            {
                title: "Comments about changes to work or employment made in a preemptive action (Open-text Response)", index: "9.2", url: "comments-about-changes", subsections: []
            },
            {
                title: "Additional details about actions taken preemptively to retain faculty (Open-text Response)", index: "9.3", url: "additional-details-about-actions", subsections: []
            },
        ]

    },
    {
        title: "Appendix",
        index: "",
        url: "appendix",
        subsections: [
            {
                title: "Video Guides", index: "", url: "video-guides", subsections: []
            },
            {
                title: "Brief summary of the COACHE Faculty Retention & Exit Study", index: "", url: "brief-summary", subsections: []
            },
            {
                title: "Your commitment to confidentiality", index: "", url: "your-commitment-to-confidentiality", subsections: []
            },
            {
                title: "Eligible population", index: "", url: "eligible-population", subsections: []
            },
            {
                title: "Administration", index: "", url: "administration", subsections: []
            },
            {
                title: "Reporting/Analysis", index: "", url: "reporting-analysis", subsections: []
            },
            {
                title: "References", index: "", url: "references", subsections: []
            },
            {
                title: "How to contact COACHE", index: "", url: "how-to-contact-coache", subsections: []
            },
            {
                title: "The Analytic Sample - Grants From External Sources", index: "", url: "the-analytic-sample-grants-from-external-sources", subsections: []
            },
            {
                title: "The Analytic Sample - Academic Analytics", index: "", url: "the-analytic-sample-academic-analytics", subsections: []
            },
            {
                title: "The Analytic Sample - Missing Data", index: "", url: "the-analytic-sample-missing-data", subsections: []
            },
            {
                title: "The Analytic Sample - Response Rates", index: "", url: "the-analytic-sample-response-rates", subsections: []
            },
            {
                title: "The Negotiation Terms - Rank Tenure Title", index: "", url: "the-negotiation-terms-rank-tenure-title", subsections: []
            },
        ]
    }
]

export function buildLookupMap(sections: Section[], map: Map<string, Section> = new Map()): Map<string, Section> {
    for (const section of sections) {
        map.set(section.title, section);
        buildLookupMap(section.subsections, map);
    }
    return map;
}